<template>
  <div class="ad-container flex flex-y">
    <div class="flex-1" style="overflow: auto;">
      <van-image :src="$oss(28)"></van-image>
      <div class="ad-body-box">
        <div class="flex align-center justify-around padding-tb-20">
          <div
            v-for="item in list"
            :key="item.icon"
            class="flex flex-y align-center"
          >
            <van-image :src="$oss(item.icon)" width="50"></van-image>
            <div class="text-12 margin-top-8">{{ item.text }}</div>
          </div>
        </div>

        <div class="padding-lr-16">
          <div
            v-for="item in menu"
            :key="item.icon"
            class="ad-menu-item flex align-center"
          >
            <van-image :src="$oss(item.cover)" width="55"></van-image>
            <div class="flex-1 padding-left-14">
              <div class="text-bold text-16">{{ item.title }}</div>
              <div class="flex margin-top-6">
                <van-image :src="$oss(item.icon)" width="15" height="15"></van-image>
                <div class="text-12 text-primary margin-left-4">
                  {{ item.tip }}
                </div>
              </div>
            </div>

            <div
              class="
                bg-primary
                text-white
                padding-lr-14 padding-tb-8
                text-12
                flex
                align-center
              "
              style="border-radius: 20px"
              @click="$router.push(item.url)"
            >
              <span class="margin-right-4">立即注册</span>
              <van-image :src="$oss(21)" width="9"></van-image>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-center margin-bottom-20">
      <van-image :src="$oss(29)" style="width: 62%"></van-image>
    </div>
  </div>
</template>

<script>
export default {
  data ({ $route }) {
    const userId = $route.params.id
    return {
      list: [
        {
          text: '更安全',
          icon: 23
        },
        {
          text: '更低碳',
          icon: 24
        },
        {
          text: '更放心',
          icon: 25
        }
      ],
      menu: [
        {
          title: '注册成为车主',
          tip: '顺路赚油费',
          cover: 26,
          icon: 20,
          url: `/promote/driver/register?userId=${userId}`
        },
        {
          title: '注册成为乘客',
          tip: '可领27元乘车优惠券',
          cover: 27,
          icon: 22,
          url: `/promote/user/register?userId=${userId}`
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.ad-container {
  background-color: #fff;
  min-height: 100vh;
}
.ad-body-box {
  background-color: #fff;
  position: relative;
  margin-top: -22px;
  z-index: 1;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.ad-menu-item {
  margin: 14px 0;
  padding: 27px 12px;
  box-shadow: 0 0 12px 0 #eee;
}
</style>
